<template>
  <div>
    <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>

    <template v-if="this.showExpireLicense">
      <div class="card mb-2">
        <b-card-header class="esep-blue-bg text-light">
          <h6  class="float-left font-weight-bold">{{ $t('leaders.expireLicense')}} - {{ this.licenseToExpire.member.surName }} {{ this.licenseToExpire.member.firstName }}</h6>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-form-group
              id="input-group-comment-reject"
              :label="$t('leaders.expireComments')"
              label-for="input-comment"
              label-align="left"
              class="col-md-6"
            >
              <b-form-input
                id="input-comment"
                v-model="expireComments"
                type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-dueDate"
              :label="$t('leaders.dueDate')"
              label-for="dueDate-datepicker"
              label-align="left"
              class="col-3"
            >   
                <b-form-datepicker
                  id="dueDate-input"
                  v-model="dueDate"
                  autocomplete="off"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  locale="en-GB"
                  placeholder=""
                  value-as-date
                  class="col-12"
                ></b-form-datepicker>
            </b-form-group>
          </b-row>
          <div class="float-left mt-2">
            <b-button @click="submitExpireLicense" variant="primary" class="mr-1 esep-blue-bg" :disabled="!dueDate || !expireComments">{{
              $t("common.submit")
            }}</b-button>
            <b-button @click="expireLicense(null)" variant="danger" >{{
              $t("common.cancel")
            }}</b-button>
          </div>
        </b-card-body>
      </div>
    </template>

    <div class="row mx-1 mt-1">
      <b-select v-model="perPage" :options="pageOptions" class="pageSizeClass">
      </b-select>
      <b-input 
        id="search-input" 
        class="col-md-6 col-lg-4 ml-2 mb-2 mb-sm-0" 
        :placeholder="$t('leaders.leadersSearchBy')"
        v-model="searchString"
      ></b-input>
      <router-link :to="{name: 'leaderAdd'}" class="ml-auto">
        <b-button class="esep-blue-bg " variant="primary">
          {{ $t("leaders.addLeaders") }}
        </b-button>
      </router-link>
    </div>
    <b-table 
      :busy="!leaders || downloading"
      :items="leaders"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      ref="leadersTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="editLeader(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('leaders.editLeader')"
        >
          <b-icon icon="pencil-square" ></b-icon>
        </b-button>

        <b-button
          size="sm"
          @click="getLeadersLogbook(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('leaders.getLogbook')"
        >
          <b-icon icon="file-earmark-arrow-down" ></b-icon>
        </b-button>

        <b-button
          size="sm"
          @click="expireLicense(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('leaders.expireLicense')"
        >
          <b-icon icon="box-arrow-right" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("leaders.emptyLeadersTable") }}</h6>
      </template>

      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="leaders-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import trainingService from '../../services/training.service';
import { handleApiError } from "../../services/error.service";

export default {
  computed: {
    rows() {
      return this.leaders? this.leaders.length : 0;
    }
  },
  props: {
    leaders: Array
  },
  data() {
    return {
      popSuccessAlert: false,
      successMessage: null,
      showExpireLicense: false,
      expireComments: null,
      dueDate: null,
      licenseToExpire: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "All",
        },
      ],
      sortBy: "member",
      sortDesc: false,
      fields: [
        { key: "memberId", label: "Αριθμός Μητρώου", sortable: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "member", label: "Επώνυμο", sortable: true, sortByFormatted: true, filterByFormatted: true, formatter: "showSurname", thClass: 'text-left', tdClass: 'text-left' },
        { key: "member.firstName", label: "Όνομα", sortable: false, thClass: 'text-left', tdClass: 'text-left'},
        { key: "member.unit.name", label: "Κλιμάκιο", sortable: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "status", label: "Κατάσταση", ortable: true, sortByFormatted: true, formatter: "translateStatus", thClass: 'text-left', tdClass: 'text-left'},
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      filterOn: ["member"],
      searchString: "",
      downloading: false
    }
  },
  watch: {
    searchString: function () {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.$emit('refresh-list', {search: this.searchString});
          this.awaitingSearch = false;
        }, 500); // 0.5 sec delay
      }
      this.awaitingSearch = true;
    },
  },
  methods: {

    showSurname(member) {
      return member.surName;
    },
    translateStatus(status) {
      return this.$t(`licenseStatusEnums.${status}`);
    },
    editLeader(row) {
      this.$log.debug(row);
      this.$router.push({name: 'leaderEdit',params: { id: row.item.id }});
    },
    getLeadersLogbook(row) {
      this.downloading = true;
      const fileDownload = require('js-file-download');
      console.error(row.item.member.id);
      trainingService.downloadLeadersLogbook(row.item.member).then(
        (response) => { 
          fileDownload(response.data, `${row.item.member.id}-logbook.pdf`);
          this.downloading = false;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.downloading = false;
          this.$emit('error:api', errorMessage);
        }
      )
    },
    expireLicense(row) {
      if(row) {
        this.licenseToExpire = row.item
        this.showExpireLicense= true;
        window.scroll(0,0)
      } else {
        this.licenseToExpire = null;
        this.showExpireLicense = false;
      }
    },
    submitExpireLicense() {
      trainingService.expireLeaderLicense(this.licenseToExpire.id, this.expireComments, this.dueDate).then(
        () => {
          this.expireComments = null;
          this.dueDate = null;
          this.expireLicense(null);
          this.$emit('refresh-list', {message: this.$t('leaders.licenseExpired')});
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>